var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-img",style:({height: _vm.config.height + 'px', borderRadius: _vm.config.borderRadius + 'px', backgroundImage: ("url(" + (_vm.config.img) + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }